import {
  AccountingJobProps as AccountingJob,
  AccountingJobStateEnum,
  AccountingJobTypeEnum,
  formatDate,
} from '@ui/src';

import getProgress from './get-progress';

import cn from '../styles.module.css';

const formatAccountingManagmentList = (
  list: AccountingJob[],
): AccountingJob[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {};

    let typeName: React.ReactElement | string = '';
    let fullCurrentDate = '';
    let finishedAt = '-';

    const {
      progress,
      balanceLogsProgress,
      balanceSheetProgress,
      revaluationProgress,
    } = getProgress(result);

    if (result.type === AccountingJobTypeEnum.BALANCE_SHEET) {
      typeName = 'Reports';
      fullCurrentDate = result?.balanceSheetCurrentDate
        ? formatDate(result.balanceSheetCurrentDate.split('T')[0])
        : '-';
    } else if (result.type === AccountingJobTypeEnum.REVALUATION) {
      typeName = 'Revaluations';
      fullCurrentDate = result?.revaluationCurrentDate
        ? formatDate(result.revaluationCurrentDate.split('T')[0])
        : '-';
    } else if (result.type === AccountingJobTypeEnum.POST_PROCESSING) {
      fullCurrentDate = result?.postProcessingCurrentDate
        ? formatDate(result.postProcessingCurrentDate.split('T')[0])
        : '-';
      typeName = (
        <span>
          Recalculation of transaction amounts in the base currency /
          <br />
          Creation of missing statement items
        </span>
      );
    } else if (result.type === AccountingJobTypeEnum.BALANCES_LOGS) {
      typeName = 'Closing balances / Reports / Revaluations';
    }

    if (result?.cancelledAt) {
      finishedAt = formatDate(result?.cancelledAt, true);
    } else if (result?.finishedAt) {
      finishedAt = formatDate(result.finishedAt, true);
    }

    render.type = <div className={cn.accountingJobType}>{typeName}</div>;
    render.state = (
      <div
        className={
          result.state === AccountingJobStateEnum.FAILED
            ? cn.jobStateFailed
            : ''
        }
      >
        {result?.state
          ?.split('_')
          ?.map(
            (stateValue) =>
              `${stateValue.charAt(0)}${stateValue.slice(1).toLowerCase()}`,
          )
          .join(' ')}
      </div>
    );
    render.createdAt = (
      <div className={cn.rowWithPadding}>
        {result?.createdAt ? formatDate(result.createdAt, true) : '-'}
      </div>
    );
    render.periodFrom = (
      <div className={cn.rowWithPadding}>
        {result?.periodFrom ? formatDate(result.periodFrom.split('T')[0]) : '-'}
      </div>
    );
    render.periodTo = (
      <div className={cn.rowWithPadding}>
        {result?.periodTo ? formatDate(result.periodTo.split('T')[0]) : '-'}
      </div>
    );
    render.accountsIds = (
      <div
        className={`${cn.rowWithPadding} ${
          !result?.accountsIds?.length ? cn.greyColor : ''
        }`}
      >
        {result?.accountsIds && result?.accountsIds?.length > 0
          ? result?.accountsIds?.length
          : 'All'}
      </div>
    );
    render.fullCurrentDate = (
      <div className={cn.rowWithPadding}>
        {result?.type !== AccountingJobTypeEnum.BALANCES_LOGS ? (
          fullCurrentDate
        ) : (
          <div className={cn.balanceLogsDatesWrapper}>
            {(result.balanceSheetCurrentDate ||
              result.balancesLogsCurrentDate ||
              result.revaluationCurrentDate) && (
              <div className={cn.balanceLogsDatesTooltip}>
                1 – Closing Balances
                <br />
                2 – Reports
                <br />3 – Revaluation
              </div>
            )}
            <div className={cn.accountingJobDate}>
              {`${
                result.balancesLogsCurrentDate
                  ? `${formatDate(
                      result?.balancesLogsCurrentDate.split('T')[0],
                    )} / `
                  : ''
              }${
                result.balanceSheetCurrentDate
                  ? `${formatDate(
                      result.balanceSheetCurrentDate.split('T')[0],
                    )} / `
                  : ''
              }${
                result.revaluationCurrentDate
                  ? formatDate(result.revaluationCurrentDate.split('T')[0])
                  : ''
              }`}
            </div>
          </div>
        )}
        {result?.type === AccountingJobTypeEnum.BALANCES_LOGS &&
          !result.balanceSheetCurrentDate &&
          !result.balancesLogsCurrentDate &&
          !result.revaluationCurrentDate &&
          '-'}
      </div>
    );
    render.startedAt = (
      <div className={cn.rowWithPadding}>
        {result?.startedAt ? formatDate(result.startedAt, true) : '-'}
      </div>
    );
    render.finishedAt = <div>{finishedAt}</div>;
    render.progress = (
      <div
        className={`${cn.jobProgress} ${
          progress === 100 ? cn.greenColor : ''
        } ${result.state === AccountingJobStateEnum.FAILED ? cn.redColor : ''}`}
      >
        {result.type === AccountingJobTypeEnum.BALANCES_LOGS &&
          (revaluationProgress?.toString() ||
            balanceLogsProgress?.toString() ||
            balanceSheetProgress?.toString()) && (
            <div className={cn.jobProgressTooltip}>
              {`Closing Balances: ${balanceLogsProgress}%`}
              <br />
              {`Reports: ${balanceSheetProgress}%`}
              <br />
              {`Revaluation: ${revaluationProgress}%`}
            </div>
          )}
        <div className={cn.progressValue}>
          {progress > 0 ? `${progress}%` : '-'}
        </div>
        {progress > 0 && (
          <div className={cn.progressLine}>
            <div className={cn.progressBar} style={{ width: `${progress}%` }} />
          </div>
        )}
      </div>
    );

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatAccountingManagmentList;
